import React from "react";
import PropTypes from "prop-types";
import { experimentalStyled as styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import {
  MdAccountCircle,
  MdCake,
  MdCheckCircle,
  MdOutlineAlternateEmail,
  MdCancel,
} from "react-icons/md";
import { FaUserEdit, FaUser } from "react-icons/fa";
import { BsFillTelephoneFill, BsPersonFill } from "react-icons/bs";

import { useStyles } from "./Styles";
import { PatientData } from "../Contexts";
import { Divider } from "@mui/material";

const Item = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  boxShadow: "none",
}));
const Right = styled(Paper)(({ theme }) => ({
  float: "right",
  boxShadow: "none",
  margin: "0 8px 2px 0",
  fontWeight: "600",
  paddingLeft: theme.spacing(1),
}));
const Inline = styled(Paper)(({ theme }) => ({
  display: "inline-flex",
  paddingLeft: theme.spacing(1),
  boxShadow: "none",
  alignItems: "center",
}));

export default function PatientInfo() {
  const styles = useStyles();
  const patient = React.useContext(PatientData);

  return (
    <Grid
      container
      className="patient-info-container"
      direction="row"
      justifyContent="baseline"
      sx={{ fontSize: "16px", lineHeight: "1.43", letterSpacing: "0.01071em" }}
      p={1}
    >
      <Grid item xs={12} sm={11}>
        <Grid item xs={12} pl={2} pr={2} pt={1} pb={1}>
          <Card>
            <CardContent>
              <Item>
                <Inline>
                  <FaUser className={styles.avatar} />
                  <span className={styles.label}>Name: </span>
                  <Right>{patient.first_name + " " + patient.last_name} </Right>

                  {patient.member_id && (
                    <>
                      {" "}
                      <span className={styles.label}>Member ID#: </span>{" "}
                      <Right>{patient.member_id}</Right>
                    </>
                  )}
                </Inline>{" "}
                <br />
                <Inline>
                  <MdCake className={styles.labelIcon} />
                  <span className={styles.label}>DOB: </span>
                  <Right> {patient.birth_date}</Right>
                </Inline>
                {patient.phone && (
                  <Inline>
                    <BsFillTelephoneFill className={styles.labelIcon} />{" "}
                    <span className={styles.label}>Phone: </span>
                    <Right>{patient.phone}</Right>
                  </Inline>
                )}
                {patient.email && (
                  <Inline>
                    <MdOutlineAlternateEmail className={styles.labelIcon} />
                    <span className={styles.label}>Email: </span>
                    <Right>{patient.email}</Right>
                  </Inline>
                )}
                <br />
                <Inline>
                  {patient.patient_consented_to_notifications ? (
                    <MdCheckCircle className={styles.checkIcon} />
                  ) : (
                    <MdCancel className={styles.xIcon} />
                  )}{" "}
                  <Right>
                    <span className={styles.label}>Consented to Notifications </span>
                  </Right>
                </Inline>
                <Inline>
                  {patient.established ? (
                    <MdCheckCircle className={styles.checkIcon} />
                  ) : (
                    <MdCancel className={styles.xIcon} />
                  )}{" "}
                  <Right>
                    <span className={styles.label}>wellPORTAL Established</span>
                  </Right>
                </Inline>
              </Item>
              <Divider />
              <Item>
                <Inline>
                  <span className={styles.label}>Health Plan: </span>
                  <Right> {patient.health_plan} </Right>
                </Inline>
                <Inline>
                  <span className={styles.label}>Plan Sponsor: </span>
                  <Right> {patient.plan_sponsor}</Right>
                </Inline>
                <Inline>
                  <span className={styles.label}>Program: </span>
                  <Right>{patient.program}</Right>
                </Inline>
                <br />
                <Inline>
                  <span className={styles.label}> Elected PCP: </span>
                  <Right> {patient.pcp}</Right>
                </Inline>
                {patient.pcp_practice && patient.pcp_practice.id && (
                  <>
                    <Inline>
                      <span className={styles.label}>PCP Practice: </span>
                      <Right>{patient.pcp_practice.name}</Right>
                    </Inline>

                    {patient.pcp_practice.phone_number && (
                      <Inline>
                        <span className={styles.label}>PCP Phone: </span>
                        <Right>{patient.pcp_practice.phone_number}</Right>
                      </Inline>
                    )}
                  </>
                )}
              </Item>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Grid>
  );
}
